var storefrontApp = angular.module("storefrontApp");
storefrontApp.service("commonService", [
    "$http",
    function ($http) {
        return {
            copyToClipboard: function (text) {
                var copied = false;
                var textArea = document.createElement("textarea");

                textArea.value = text;
                textArea.style.top = "0";
                textArea.style.left = "0";
                textArea.style.position = "fixed";

                document.body.appendChild(textArea);
                textArea.focus();
                textArea.select();

                try {
                    copied = document.execCommand("copy");
                } catch (_err) {}

                document.body.removeChild(textArea);
                return copied;
            },
            formatMoney: function (
                number,
                decimalPlaces,
                decimalSeparator,
                thousandsSeparator
            ) {
                var n = number,
                    c = isNaN((decimalPlaces = Math.abs(decimalPlaces)))
                        ? 2
                        : decimalPlaces,
                    d = decimalSeparator == undefined ? "." : decimalSeparator,
                    t =
                        thousandsSeparator == undefined
                            ? ","
                            : thousandsSeparator,
                    s = n < 0 ? "-" : "",
                    i = parseInt((n = Math.abs(+n || 0).toFixed(c))) + "",
                    j = (j = i.length) > 3 ? j % 3 : 0;
                return (
                    s +
                    (j ? i.substr(0, j) + t : "") +
                    i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) +
                    (c
                        ? d +
                          Math.abs(n - i)
                              .toFixed(c)
                              .slice(2)
                        : "")
                );
            },
            getCookie: function (key) {
                var cookie = document.cookie.match(
                    new RegExp("(^| )" + key + "=([^;]+)")
                );
                return cookie ? cookie[2] : null;
            },
            getCountries: function () {
                return $http.get(
                    "storefrontapi/countries?t=" + new Date().getTime()
                );
            },
            getCountryRegions: function (countryCode) {
                return $http.get((
                    "storefrontapi/countries/" +
                        countryCode +
                        "/regions?t=" +
                        new Date().getTime()
                ).toLowerCase());
            },
            getFormats: function () {
                return $http.get(
                    "storefrontapi/account/formats?t=" + new Date().getTime()
                );
            },
            getGDPRExpiration: function () {
                return $http.get("storefrontapi/getgdprexpiration");
            },
            getHTMLTextNodes: function (node) {
                var textNodes = [];
                function getTextNodeRecursive(node) {
                    if (node.nodeType == 3)
                        new RegExp(/\S/).test(node.nodeValue) &&
                            textNodes.push(node);
                    else
                        node.childNodes.forEach(function (x) {
                            getTextNodeRecursive(x);
                        });
                }
                getTextNodeRecursive(node);
                return textNodes;
            },
            getMonths: function () {
                return $http.get(
                    "storefrontapi/common/months?t=" + new Date().getTime()
                );
            },
            getStoreAndLocalCurrency: function () {
                return $http.get(
                    "storefrontapi/common/storeandlocalcurrency?t=" +
                        new Date().getTime()
                );
            },
            getSplPageAds: function() {
                return $http.get('storefrontapi/common/specialspage-content');
            },
            getFreeListingsBanners: function() {
                return $http.get('storefrontapi/common/freelistings-banners');
            },
            isSuspectUserRestrictionEnabled: function () {
                return $http.get(
                    "storefrontapi/common/suspectuserrestrictionenabled"
                );
            },
            setCookie: function (name, value, days) {
                var expires = "";
                if (days) {
                    var date = new Date();
                    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
                    expires = "; expires=" + date.toString();
                }
                document.cookie = name + "=" + value + expires + "; path=/";
            },
        };
    },
]);
